import { render, staticRenderFns } from "./SubscriptionTouchActions.vue?vue&type=template&id=1ce7a6a6&scoped=true&"
import script from "./SubscriptionTouchActions.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionTouchActions.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionTouchActions.vue?vue&type=style&index=0&id=1ce7a6a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce7a6a6",
  null
  
)

export default component.exports